import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function ArticlesPage() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${t('nav.article')} - ${t('site.name')}`,
        description: `黄桃视频最新文章资讯与观影指南`,
        url: 'https://huangtao.com/articles',
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: t('breadcrumb.home'), item: 'https://huangtao.com' },
          { '@type': 'ListItem', position: 2, name: t('nav.article') },
        ],
      }} />

      <div className="max-w-[1440px] mx-auto px-4 md:px-6 pt-24 pb-12 md:pb-16">
        <Breadcrumb
          items={[
            { label: t('breadcrumb.home'), path: '/' },
            { label: t('nav.article') },
          ]}
        />

        <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
          {t('nav.article')}
        </h1>
        <p className="text-sm text-foreground-500 mb-8">
          了解黄桃视频最新动态、观影指南与平台资讯
        </p>

        <div className="flex flex-col gap-4">
          {articles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </>
  );
}